import { useMutation, useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { AppointmentData } from '@/features/reviews';

export type NotificationRes = {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
  list: Notifications[];
  unread?: any;
};

type UseBusinessOptions = {
  page?: number;
  perPage?: number;
  businessId?: number;
  isSingleRead?: boolean;
  notificationId?: any;
  parentId?: any;
};

export const getNotifications = ({
  page = 1,
  perPage = 10,
  businessId,
}: UseBusinessOptions): Promise<NotificationRes> => {
  return axios.get(`/business/notifications/list`, {
    params: {
      page,
      perPage,
      businessId,
    },
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getNotifications>;
};

export const useGetNotifications = ({ config }: UseUpdateBusinessOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    ...config,
    mutationFn: getNotifications,
  });
};

export const markRead = ({
  businessId,
  isSingleRead,
  notificationId,
  parentId,
}: UseBusinessOptions): Promise<NotificationRes> => {
  if (isSingleRead) {
    return axios.post(`/business/notifications/mark`, {
      params: {
        businessId,
        id: notificationId,
        parentId,
      },
    });
  } else {
    return axios.post(`/business/notifications/multi-mark`, {
      params: {
        businessId,
      },
    });
  }
};

type UseUpdateBusinessOptions1 = {
  config?: MutationConfig<typeof markRead>;
};

export const useGetMarkRead = ({ config }: UseUpdateBusinessOptions1 = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    ...config,
    mutationFn: markRead,
  });
};

export const getUnreadNotifications = ({
  page = 1,
  perPage = 10,
}: UseBusinessOptions): Promise<NotificationRes> => {
  return axios.get(`/business/notifications/unread`, {
    params: {
      page,
      perPage,
    },
  });
};

type UseUpdateBusinessOptions2 = {
  config?: MutationConfig<typeof getUnreadNotifications>;
};

export const useGetUreadNotifications = ({ config }: UseUpdateBusinessOptions2 = {}) => {
  return useMutation({
    ...config,
    mutationFn: getUnreadNotifications,
  });
};

export type Notifications = {
  appointmentId?: string;
  appointment?: AppointmentData;
  businessId?: string;
  businessLocationId?: string;
  businessUser?: string;
  isRead?: string;
  id?: string;
  notificationType?: string;
  notifyHtml?: string;
  parentId?: string;
  parentName?: string;
  readTime?: string | null;
  source?: string;
  templateName?: string;
  toUserId?: string;
  updatedAt?: string;
  createdAt: any;
  parent?: any;
};
